<div class="h-full overflow-hidden">
  <p-scroll-panel class="h-full">
    <form [formGroup]="form">
      <div class="control">
        <label>Regnr</label>
        <input pInputText formControlName="regnr" />
      </div>
      <div class="control">
        <label>Letsikring nr</label>
        <input pInputText formControlName="letsikringNr" />
      </div>
      <div class="control">
        <label>Clearingsresultat</label>
        <p-select
          [options]="clearingsResultatTypeOptions"
          [showClear]="true"
          formControlName="clearingsResultatType"
          optionLabel="text"
          optionValue="value"
          appendTo="body" />
      </div>
      <div class="control">
        <label>Hændelseskode</label>
        <input pInputText formControlName="haendelsesKode" />
      </div>
      <div class="control">
        <label>Årsag</label>
        <input pInputText formControlName="aarsag" />
      </div>
      <div class="control">
        <label>Produkt type</label>
        <p-select
          [options]="produktTypeService.produktTypeOptions()"
          [showClear]="true"
          formControlName="produktType"
          appendTo="body" />
      </div>
      <div class="control">
        <label>Forsikringstager Cpr </label>
        <input pInputText formControlName="forsikringstagerCpr" />
      </div>
      <div class="control">
        <label>Status</label>
        <p-select
          [options]="statusOptions"
          [showClear]="true"
          formControlName="status"
          optionLabel="text"
          optionValue="value"
          appendTo="body" />
      </div>

      <div class="flex gap-2">
        <p-button
          label="Søg"
          (click)="onClickSearch()"
          [loading]="opkraevningUdestaaendeService.datasource.isLoading()"
          icon="pi pi-search"
          type="submit" />
        <p-button
          label="Nulstil"
          (click)="onClickReset()"
          icon="pi pi-times"
          severity="secondary"
          outlined />
      </div>
    </form>
    @if (noHits()) {
      <p-message text="Ingen hits" severity="error" styleClass="mt-4" />
    }
  </p-scroll-panel>
</div>
